import React from "react";
import Home from "./page/Home";
import AboutUs from "./Commponents/About Us";
import OurServices from "./Commponents/Our Services";
import HireDeveloper from "./Commponents/Hire Developer";
import ContactUs from "./Commponents/ContactUs";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Commponents/HeadFoot/Header";
import Footer from "./Commponents/HeadFoot/Footer";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./GlobalStyle";
import MobileAppDev from "./Commponents/MobileAppDev";
import GameDevelopment from "./Commponents/GameDevelopment";
import WebDevelopment from "./Commponents/WebDevelpment";
import UiUx from "./Commponents/UiUx";
import ArVr from "./Commponents/ArVr";
import GameArt from "./Commponents/GameArt";
import Portfolio from "./Commponents/Portfolio";
import GamePortfolio from "./Commponents/GamePortfolio";

const App = () => {
  const theme = {
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgb(24 24 29)",
      white: "#fff",
      black: " #212529",
      helper: "#8490ff",
      bg: "rgb(249 249 255)",
      footer_bg: "#0a1435",
      btn: "rgb(98 84 243)",
      border: "rgba(98, 84, 243, 0.5)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: { mobile: "768px", tab: "998px" },
  };
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            {/* <Route path="/service" element={<OurServices />} /> */}
            <Route path="/hiredeveloper" element={<HireDeveloper />} />
            <Route path="/ContactUs" element={<ContactUs />} />
            {/* <Route path="/mobileappdev" element={<MobileAppDev />} /> */}
            {/* <Route path="/gamedevelopment" element={<GameDevelopment />} /> */}
            {/* <Route path="/webdevelopment" element={<WebDevelopment />} /> */}
            {/* <Route path="/uiux" element={<UiUx />} /> */}
            {/* <Route path="/arvr" element={<ArVr />} /> */}
            {/* <Route path="/gameart" element={<GameArt />} /> */}
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/gameportfolio" element={<GamePortfolio />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
};

export default App;
